export default __webpack_public_path__ + "static/media/cards.a968b7a1.svg";